export default "https://cdn-static.gokick.com/assets/9903fb7c557cf9d7d858f1d02aec0837d292f7c0/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";